import { UrlParams } from '../models/url-params';


export function urlBuilder(
  url: Array<string | number>,
  params?: UrlParams
): string {
  let formattedUrl = '';
  for (const u of url) {
    formattedUrl = formattedUrl.concat(u.toString(), '/');
  }
  formattedUrl = formattedUrl.slice(0, formattedUrl.length - 1);

  if (params) {
    formattedUrl = formattedUrl.concat('?');
    for (const prop in params) {
      if (params[prop]) {
        formattedUrl = formattedUrl.concat(
          prop,
          '=',
          params[prop].toString(),
          '&'
        );
      }
    }
    formattedUrl = formattedUrl.slice(0, formattedUrl.length - 1);
  }
  return formattedUrl;
}



// WEBPACK FOOTER //
// ./src/app/urlBuilder.ts